import { render } from "./LetterList.vue?vue&type=template&id=89bc7a28&ts=true"
import script from "./LetterList.vue?vue&type=script&lang=ts"
export * from "./LetterList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__